import BaseCdeIcon, { CdeIconProps } from './BaseCdeIcon'
import { ReactComponent as Review } from '../../../assets/permission-icons/review.svg'

const CdeIconReview: React.FC<CdeIconProps> = ({ status, onClick }) => {
  return <BaseCdeIcon onClick={onClick} status={status} icon={<Review />} />
}

export default CdeIconReview
